export enum RoleManagement {
  Items = "Items",
  Roles = "Roles",
  Tags = "Tags",
  Tests = "Tests",
  Users = "Users",
  Reports = "Reports",
  Examinees = "Examinees",
  Collections = "Collections",
  RoleDisabled = "RoleDisabled",
  Subscription = "subscription",
  Assessments = "Assessments",
  Home = "Home"
}

export enum AccountAdminRole {
  accountAdmin = "Account Admin"
}
